<!--  -->
<template>
  <div>
    <div class="strate_box">
      <div>
        策略名称：
      </div>
      <el-input v-model="strategyinput" style="width:150px" placeholder="请输入内容" />
    </div>
    <div class="strate_box">
      <div>
        策略平台：
      </div>
      <el-select v-model="mstrategy" filterable placeholder="请选择" @change="strategyplatform">
        <el-option
          v-for="item in options"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
    </div>
    <div class="strate_box">
      <div>选择标签组：</div>
      <el-select v-model="labelgroupid" :disabled="optionsr.length===0" placeholder="请选择">
        <el-option
          v-for="item in optionsr"
          :key="item.id"
          :label="item.tagGroupName"
          :value="item.id"
        />
      </el-select>
      <el-button v-if="labelgroupid" style="margin-left:10px" size="mini" type="primary" @click="labelpreview ">预览</el-button>
    </div>
    <div class="strate_box">
      <div>
        策略类型：
      </div>
      <el-radio-group v-model="strategytype" @change="strategychange">
        <el-radio v-for="item,index in strategytypearr" :key="index" :label="item.key">{{ item.value }}</el-radio>
      </el-radio-group>
    </div>
    <div v-show="strategytype === 1">
      <div class="strate_box">
        <div>
          延时时间：
        </div>
        <div>
          <el-input v-model="durationtime" style="width:150px" placeholder="输入延迟时间" @input="invokeaction" /><span>分钟</span>
        </div>
      </div>
      <div class="strate_box">
        <div>
          延迟动作：
        </div>
        <el-select v-model="delaytypevalue" filterable placeholder="请选择" @change="triggeraction">
          <el-option
            v-for="item in delaytypearr"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          />
        </el-select>
      </div>
      <Delaystrategytemp ref="subrrr" :selectoptionse="selectoptions" :oneselectarr="oneselectarr" :twoselectarr="twoselectarr" @gion="gion" />

    </div>
    <div v-show="strategytype === 2">
      <div v-for="item,index in copy" :key="index">
        <div>
          <div class="strate_box">
            <div>
              关键字回复：
            </div>
            <div>
              <el-input v-model="item.rascalkeywords" style="width:150px" placeholder="输入关键词回复" @input="rascalkeywordsinput" />
              <el-button type="primary" class="copy_box" @click="copyclick(item.messageradio)">复制</el-button>
              <el-button v-if="index !== 0" type="primary" @click="deleteitem(index)">删除</el-button>
            </div>
          </div>

          <div class="strate_box">
            <div>
              消息类型：
            </div>
            <div>
              <el-radio-group v-model="item.messageradio" @change="messagechange(item,index)">
                <el-radio v-for="items,indexs in meassagearr" :key="indexs" :label="items.key">{{ items.value }}</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div v-if="item.messageradio === 1">
            <div class="strate_box">
              <div>
                选择的消息：
              </div>
              <div>
                {{ item.messagename }}
              </div>
            </div>
            <el-input v-model="item.title" clearable style="width:200px;" placeholder="请输入标题" />
            <el-input v-model="item.customerMessageNo" clearable style="width:200px;margin:0 20px" placeholder="请输入编号" />
            <el-select v-model="item.msgType" placeholder="请选择">
              <el-option
                v-for="itemr in selectoptions"
                :key="itemr.key"
                :label="itemr.value"
                :value="itemr.key"
              />
            </el-select>
            <el-button type="primary" icon="el-icon-search" @click="searchclick(1,index,item)">搜索</el-button>
            <el-button type="primary" @click="rechargeclick(1,index,item)">重置</el-button>
            <el-table
              :key="item.refreshKey"
              :data="item.tabledata"
              style="width: 100%"
            >
              <el-table-column

                label="选项"
                width="100"
              >
                <template slot-scope="scope">
                  <input
                    v-model="scope.row.checkboxFlag"
                    type="checkbox"
                    @click="handleChangeSelectone(scope.$index,index)"
                  >
                  {{ scope.row.$index }}
                </template>
              </el-table-column>
              <el-table-column
                prop="customerMessageNo"
                label="编号"
              />
              <el-table-column
                prop="title"
                label="标题"
              />
              <el-table-column
                prop="msgTypeStr"
                label="类型"
              />
              <!-- :key="refreshKey" -->
              <el-table-column

                label="操作"
                width="100"
              >
                <template slot-scope="scope">
                  <el-button type="primary" @click="timingpreview(scope.row,1)">预览</el-button>
                </template>
              </el-table-column>
            </el-table>
            <pagination-right
              ref="paginationbox"
              :total="item.total"
              @size-change="fetchPageSize($event,index,item)"
              @current-change="fetchCurrentPage($event,index,item)"
            />
          </div>
          <div v-else>
            <div class="strate_box">
              <div>
                选择的消息：
              </div>
              <div>
                {{ item.templatename }}
              </div>
            </div>
            <el-table
              :key="item.refreshKeyr"
              :data="item.templatedata"
              style="width: 100%"
            >
              <el-table-column

                label="选项"
                width="100"
              >
                <template slot-scope="scope">
                  <input
                    v-model="scope.row.checkboxFlag"
                    type="checkbox"
                    @click="handleChangeSelect(scope.$index,index)"
                  >
                  {{ scope.row.$index }}
                </template>
              </el-table-column>
              <el-table-column
                prop="templateMessageAdminNo"
                label="编号"
              />
              <el-table-column
                prop="title"
                label="标题"
              />
              <!-- :key="refreshKeyr" -->
              <el-table-column

                label="操作"
                width="100"
              >
                <template slot-scope="scope">
                  <el-button type="primary" @click="timingpreview(scope.row,2)">预览</el-button>
                </template>
              </el-table-column>
            </el-table>
            <pagination-right
              :total="item.temtotal"
              @size-change="fetchPageSizeone($event,index,item)"
              @current-change="fetchCurrentPageone($event,index,item)"
            />
          </div>
        </div>

      </div>

    </div>
    <div v-show="strategytype === 3">
      <div class="strate_box">
        <div>
          定时推送：
        </div>
        <div>
          <el-time-picker
            v-model="value1"
            placeholder="任意时间点"
            format="HH:mm"
            :clearable="false"
            @change="timechange"
          />
        </div>
      </div>
      <Strategyfactory ref="twosubrrr" :oneselectarr="oneselectarr" :twoselectarr="twoselectarr" :selectoptionse="selectoptions" @gione="gione" />
    </div>

    <div>
      <el-button type="primary" size="mini" @click="saveclick">保存</el-button>
    </div>

    <!-- 预览标签组弹窗 -->
    <el-dialog
      title="预览"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      width="30%"
    >
      <Labelgroupdialog ref="labeldialog" :optionsr="optionsr" />
    </el-dialog>

    <!-- 预览标签组弹窗 -->
    <el-dialog
      title="预览"
      :visible.sync="priwdialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      width="30%"
    >
      <PreviewDialog ref="timepreview" />
    </el-dialog>
  </div>
</template>

<script>
import { strategyList, actionHelper, strategyPlatform, customercreatlist, customermessagelist, addstrategy, adminlist, templateadminlist } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import Delaystrategytemp from './Delaystrategytemp.vue'
import Strategyfactory from '../wew/Timingtemp.vue'
import Labelgroupdialog from './Labelgroupdialog.vue'
import PreviewDialog from '../../timedPush/components/PreviewDialog'
import convertToHump from '@/utils/mixins/convertToHump.js'
export default {
  components: {
    PaginationRight,
    Delaystrategytemp,
    Strategyfactory,
    Labelgroupdialog,
    PreviewDialog
  },
  mixins: [convertToHump],
  data() {
    return {
      dialogVisible: false,
      priwdialogVisible: false,

      oneselectarr: {},
      twoselectarr: {},

      delayedarror: [], //  延时策略数组
      timingarror: [], // 定时推送数组

      strategyinput: '', // 策略名称
      options: [], // 策略平台数组
      mstrategy: null, // 策略平台
      strategytypearr: [], // 策略类型
      strategytype: 1, // 策略类型 绑定值
      delaytypearr: [], // 延迟动作数组
      delaytypevalue: null, // 延迟动作 绑定值
      durationtime: null, // 延迟时间
      rascalkeywords: null, // 关键词绑定
      strategyType: {
        // delayType: null, // 延迟动作
        // duration: null// 延迟时间
        // timeHi:0850
        // keywords:[] 关键字回复
      }, // 要给后端发的策略类型的对象
      value1: new Date(2022, 6, 1, 18, 40), // 定时推送
      copy: [
        {
          rascalkeywords: null,
          messageradio: 1,
          messagename: null,
          messageid: null,
          tabledata: [],
          refreshKey: Math.random(),
          page: 1,
          pageSize: 10,
          title: null,
          msgType: null,
          customerMessageNo: null,
          total: null,
          msgid: null,

          templatename: null,
          templatedata: [],
          pages: 1,
          pageSizes: 10,
          temtotal: null,
          tempid: null,
          refreshKeyr: Math.random()
        }
      ],
      // 消息类型数组
      meassagearr: [
        {
          key: 1,
          value: '客服消息'
        },
        {
          key: 2,
          value: '模板消息'
        }
      ],
      messageradio: 1, // 消息类型绑定值
      messagequety: [], // 消息类型数组

      publicAdvertList: [], // 关键字客服消息数组
      templateAdvertList: [], // 关键字模板消息数组
      obj: {
        page: 1,
        pageSize: 10,
        title: null,
        msgType: null,
        customerMessageNo: null
      },

      selectoptions: [], // 筛选类数组
      newtotal: null,
      templatetotalr: null,

      submit: [],

      sub: {},
      subarr: [],

      testarr: [],

      optionsr: [], // 标签组数组
      labelgroupid: 0// 标签组id
    }
  },
  created() {
    this.getstrategyList()
    this.getdelayType()
    this.getstrategyplatform()
    this.typelist()
    this.gettemplatelist()
    this.initr()
    this.menuList()
    this.optionsr.push({
      id: 0,
      tagGroupName: '全部'
    })
  },
  mounted() {

  },
  methods: {
    // 初始化
    initr() {
      if (this.strategytype === 1) {
        this.strategyType.delayType = null
        this.strategyType.duration = null
      }
      if (this.strategytype === 2) {
        this.strategyType.keywords = []
      }
      if (this.strategytype === 3) {
        this.strategyType.timeHi = null
      }
    },
    // 获取策略类型
    async getstrategyList() {
      const data = await strategyList()
      this.strategytypearr = data.data
      console.log('策略类型', data)
    },
    // 获取延迟动作 接口
    async getdelayType() {
      const data = await actionHelper()
      this.delaytypearr = data.data
      console.log('延迟动作', data)
    },
    // 获取策略平台
    async getstrategyplatform() {
      const data = await strategyPlatform()
      this.options = data.data.list
      console.log('获取策略平台', data)
    },
    // 获取筛选类数组
    async typelist() {
      const data = await customermessagelist()
      this.selectoptions = data.data.list
    },
    // 获取客服消息
    menuList() {
      customercreatlist(this.obj).then(res => {
        this.copy[0].total = res.data.total
        this.copy[0].tabledata = res.data.list
        this.copy[0].tabledata.forEach(item => {
          item.checkboxFlag = false
        })

        this.oneselectarr = res.data
        this.publicAdvertList = res.data.list
        this.publicAdvertList.forEach(item => {
          item.checkboxFlag = false
        })
        this.newtotal = res.data.total
      })
    },
    // 获取客服消息分页的使用
    menuListall(e, index, item) {
      customercreatlist({
        page: e,
        pageSize: 10,
        title: item.title,
        msgType: item.msgType,
        customerMessageNo: item.customerMessageNo
      }).then(res => {
        this.copy[index].tabledata = res.data.list
        this.copy[index].total = res.data.total
        this.copy[index].tabledata.forEach(items => {
          items.checkboxFlag = false
          if (items.customerMessageNo === item.messageid) {
            items.checkboxFlag = true
          }
        })
      })
    },

    // 分页
    fetchPageSize(e, index, item) {
      this.menuListall(e, index, item)
    },
    fetchCurrentPage(e, index, item) {
      this.menuListall(e, index, item)
    },

    fetchPageSizeone(e, index, item) {
      this.gettemplatepage(e, index, item)
    },
    fetchCurrentPageone(e, index, item) {
      this.gettemplatepage(e, index, item)
    },
    // 获取模板消息 接口
    async gettemplatelist() {
      const data = await templateadminlist({
        page: 1,
        pageSize: 10
      })
      this.copy[0].temtotal = this.convertToHump(data.data.total)
      this.copy[0].templatedata = data.data.list
      this.copy[0].templatedata.forEach(item => {
        item.checkboxFlag = false
      })

      this.twoselectarr = data.data
      this.templateAdvertList = data.data.list
      this.templateAdvertList.forEach(item => {
        item.checkboxFlag = false
      })
      this.templatetotalr = data.data.total

      console.log('模板列表', data)
    },
    // 获取模板消息 接口分页
    async gettemplatepage(e, index, item) {
      const data = await templateadminlist({
        page: e,
        pageSize: 10
      })
      this.copy[index].templatedata = this.convertToHump(data.data.list)
      this.copy[index].temtotal = data.data.total
      this.copy[index].templatedata.forEach(items => {
        items.checkboxFlag = false
        if (items.templateMessageAdminNo === item.messageid) {
          items.checkboxFlag = true
        }
      })
    },
    strategychange(val) {
      console.log('val', val)
      if (val === 1) {
        this.strategyType = {}
        this.strategyType.delayType = this.delaytypevalue
        this.strategyType.duration = this.durationtime
        this.submit = []
        this.submit = this.delayedarror

        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.subrrr.send()
        }, 100)
        console.log('延时策略', this.strategyType)
      }
      if (val === 2) {
        this.strategyType = {}
        this.strategyType.keywords = this.copy
        // console.log('关键字回复', this.strategyType)
        for (let i = 0; i < this.strategyType.keywords.length; i++) {
          for (let l = 0; l < this.strategyType.keywords[i].tabledata.length; l++) {
            console.log('this.strategyType.keywords', this.strategyType.keywords[i].tabledata[l])
            this.strategyType.keywords[i].tabledata[l].checkboxFlag = false
            if (this.strategyType.keywords[i].tempid === this.strategyType.keywords[i].tabledata[l].customerMessageNo) {
              console.log('22222222222')
              this.strategyType.keywords[i].tabledata[l].checkboxFlag = true
            }
          }
        }

        for (let i = 0; i < this.strategyType.keywords.length; i++) {
          for (let l = 0; l < this.strategyType.keywords[i].templatedata.length; l++) {
            this.strategyType.keywords[i].templatedata[l].checkboxFlag = false
            if (this.strategyType.keywords[i].msgid === this.strategyType.keywords[i].templatedata[l].templateMessageAdminNo) {
              this.strategyType.keywords[i].templatedata[l].checkboxFlag = true
            }
          }
        }

        console.log('关键字回复', this.strategyType)
      }
      if (val === 3) {
        this.strategyType = {}
        const d = new Date(this.value1)
        let _h = d.getHours() + ''
        if (_h.length === 1) {
          _h = '0' + _h
        }
        let _m = d.getMinutes() + ''
        if (_m.length === 1) {
          _m = '0' + _m
        }
        this.strategyType.timeHi = _h + _m
        this.submit = []
        this.submit = this.timingarror

        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.twosubrrr.twopsend()
        }, 100)
        console.log('定时推送', this.strategyType)
      }
    },
    // 消息类型改变回调
    messagechange(item, index) {
      if (this.strategyType.keywords[index].messageradio === 1) {
        console.log('客服', item)

        this.strategyType.keywords[index].messageid = item.tempid
        this.strategyType.keywords[index].tabledata.forEach(itemr => {
          itemr.checkboxFlag = false
          if (itemr.customerMessageNo === item.tempid) {
            itemr.checkboxFlag = true
          }
        })
      } else {
        console.log('模板', item)

        this.strategyType.keywords[index].messageid = item.msgid
        this.strategyType.keywords[index].templatedata.forEach(itemr => {
          itemr.checkboxFlag = false
          if (itemr.templateMessageAdminNo === item.msgid) {
            itemr.checkboxFlag = true
          }
        })
      }
    },
    // 延迟时间 回调
    invokeaction(val) {
      this.strategyType.duration = val
    },
    // 延迟动作回调
    triggeraction(val) {
      this.strategyType.delayType = val
    },
    // 输入关键词回复
    rascalkeywordsinput(val) {
      this.strategyType.keywords = []
      this.strategyType.keywords = this.copy
    },
    // 定时时间改变回调
    timechange(val) {
      const d = new Date(val)
      let _h = d.getHours() + ''
      if (_h.length === 1) {
        _h = '0' + _h
      }
      let _m = d.getMinutes() + ''
      if (_m.length === 1) {
        _m = '0' + _m
      }
      this.strategyType.timeHi = _h + _m
    },
    // 复制
    copyclick(radio) {
      if (radio === 1) {
        this.publicAdvertList.forEach(item => {
          item.checkboxFlag = false
        })
        this.copy.push(this.Clone({
          rascalkeywords: null,
          messageradio: 1,
          messagename: null,
          messageid: null,
          tabledata: this.publicAdvertList,
          refreshKey: Math.random(),
          page: 1,
          pageSize: 10,
          title: null,
          msgType: null,
          customerMessageNo: null,
          total: this.newtotal,
          msgid: null,

          templatedata: this.templateAdvertList,
          pages: 1,
          pageSizes: 10,
          temtotal: this.templatetotalr,
          templatename: null,
          tempid: null,
          refreshKeyr: Math.random()
        }))
      }
      if (radio === 2) {
        console.log('666')
        this.templateAdvertList.forEach(item => {
          item.checkboxFlag = false
        })
        this.copy.push(this.Clone({
          rascalkeywords: null,
          messageradio: 2,
          messageid: null,
          refreshKeyr: Math.random(),
          templatedata: this.templateAdvertList,
          pages: 1,
          pageSizes: 10,
          temtotal: this.templatetotalr,
          templatename: null,
          tempid: null,

          messagename: null,
          tabledata: this.publicAdvertList,
          page: 1,
          pageSize: 10,
          title: null,
          msgType: null,
          customerMessageNo: null,
          total: this.newtotal,
          msgid: null,
          refreshKey: Math.random()
        }))
      }

      console.log(' this.copy', this.copy)
    },
    Clone(fu, zi) {
      // eslint-disable-next-line no-redeclare
      var zi = zi || {}
      var fanfa = Object.prototype.toString
      var arr = '[object Array]'
      var obj = '[object Object]'
      if (typeof (fu) === 'object') {
        for (var prop in fu) {
          // eslint-disable-next-line no-prototype-builtins
          if (fu.hasOwnProperty(prop)) {
            if (fu[prop] !== null && typeof (fu[prop]) === 'object') {
              if (fanfa.call(fu[prop]) === arr) {
                zi[prop] = []
              } else if (fanfa.call(fu[prop] === obj)) {
                zi[prop] = {}
              }
              this.Clone(fu[prop], zi[prop])
            } else {
              zi[prop] = fu[prop]
            }
          }
        }
        return zi
      }
    },
    // 删除
    deleteitem(index) {
      // this.copy.splice(index, 1)
      this.strategyType.keywords.splice(index, 1)
      // this.strategyType
    },
    // checkbox客服单选
    handleChangeSelect(index, index1) {
      if (!this.copy[index1].templatedata[index].checkboxFlag) {
        this.copy[index1].templatename = this.copy[index1].templatedata[index].title
        this.copy[index1].messageid = this.copy[index1].templatedata[index].templateMessageAdminNo
        this.copy[index1].msgid = this.copy[index1].templatedata[index].templateMessageAdminNo
      } else {
        // this.copy[index1].messagename = null
        // this.copy[index1].messageid = null
      }
      this.copy[index1].templatedata.forEach(item => {
        item.checkboxFlag = false
      })
      this.copy[index1].templatedata[index].checkboxFlag = true
      this.copy[index1].refreshKeyr = Math.random()
    },
    // checkbox模板单选
    handleChangeSelectone(index, index1) {
      if (!this.copy[index1].tabledata[index].checkboxFlag) {
        console.log('666')
        this.copy[index1].messagename = this.copy[index1].tabledata[index].title
        this.copy[index1].messageid = this.copy[index1].tabledata[index].customerMessageNo
        this.copy[index1].tempid = this.copy[index1].tabledata[index].customerMessageNo
      } else {
        // this.copy[index1].messagename = null
        // this.copy[index1].messageid = null
      }
      this.copy[index1].tabledata.forEach(item => {
        item.checkboxFlag = false
      })
      this.copy[index1].tabledata[index].checkboxFlag = true
      this.copy[index1].refreshKey = Math.random()
    },
    // 客服搜索
    searchclick(e, index, item) {
      this.menuListall(e, index, item)
    },
    // 客服重置
    rechargeclick(e, index, item) {
      item.title = null
      item.msgType = null
      item.customerMessageNo = null

      this.menuListall(e, index, item)
    },
    // 保存
    saveclick() {
      if (this.strategyType.keywords) {
        this.submit = []
        this.sub = {}
        this.subarr = []
        this.strategyType.keywords.map((item, index) => {
          const obg = {}
          obg.relationType = item.messageradio
          obg.relationId = item.messageid
          // rascalkeywords
          this.submit.push(obg)
          this.subarr.push(item.rascalkeywords)
        })
        // this.sub = this.subarr
        this.sub.keywords = []
        this.sub.keywords = this.subarr
        addstrategy({
          platformId: this.mstrategy,
          strategyType: this.strategytype,
          strategyName: this.strategyinput,
          msgData: this.submit,
          strategyData: this.sub,
          tagGroupId: this.labelgroupid
        }).then(res => {
          console.log('res', res)
        })
      } else {
        this.sub = this.strategyType
        addstrategy({
          platformId: this.mstrategy,
          strategyType: this.strategytype,
          strategyName: this.strategyinput,
          msgData: this.submit,
          strategyData: this.sub,
          tagGroupId: this.labelgroupid
        }).then(res => {
          console.log('res', res)
        })
      }
      console.log('标签组id', this.labelgroupid)
      console.log('mstrategy platformId 平台id', this.mstrategy)
      console.log('strategytype延时类型', this.strategytype)
      console.log('策略名称', this.strategyinput)
      console.log(' this.submit 消息数组', this.submit, this.strategyType)
      console.log('对应策略类型数据', this.strategyType, this.subarr)

      // addstrategy
    },
    // 策略平台变化 请求标签组 接口
    async strategyplatform(val) {
      const data = await adminlist({
        page: 1,
        page_size: 50,
        platform_id: val
      })
      this.optionsr = []
      // this.labelgroupid = null
      this.optionsr = data.data.list
      this.optionsr.unshift({
        id: 0,
        tagGroupName: '全部'
      })
      console.log('data', data)
    },
    // 预览标签组
    labelpreview() {
      this.dialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.labeldialog.labelsend(this.labelgroupid)
      }, 100)
    },
    // 客服预览
    timingpreview(val, id) {
      console.log('val', val)
      this.priwdialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.timepreview.send(val, id)
      }, 100)
    },
    gion(e, id) {
      this.submit = []
      this.delayedarror = []
      console.log(e, id)
      this.submit.push({ relationType: e.messytie, relationId: id })
      this.delayedarror.push({ relationType: e.messytie, relationId: id })
    },

    gione(e, id) {
      this.submit = []
      this.timingarror = []
      console.log(e, id)
      this.submit.push({ relationType: e.messytie, relationId: id })
      this.timingarror.push({ relationType: e.messytie, relationId: id })
    }
  }
}
</script>
<style lang="less" scoped>
/* @import url(); 引入css类 */
.strate_box{
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  div{
    flex-shrink: 0;
  }
   span{
      margin-left: 10px;
   }
}
.copy_box{
  margin-left: 10px;
}
</style>
